import { fbt } from 'fbtee'
import { Ticket } from 'lucide-react'

/** Beside the status badge for someone who holds a ticket; grey while one given to them is unconfirmed. */
export function TicketHolderIcon({ pending }: { pending?: boolean }) {
  return pending ? (
    <Ticket
      className="size-4 shrink-0 text-muted-foreground"
      aria-label={fbt('Has a ticket to confirm', 'Accessible label of the grey ticket icon next to someone given a ticket they haven’t confirmed')}
      data-testid="people-ticket-pending-mark"
    />
  ) : (
    <Ticket
      className="size-4 shrink-0 text-primary"
      aria-label={fbt('Has a ticket', 'Accessible label of the ticket icon next to a person in the event people list')}
      data-testid="people-ticket-mark"
    />
  )
}
